export const leftArrow = "/static/img/arrows.svg#leftArrow"
export const rightArrow = "/static/img/arrows.svg#rightArrow"
export const exitIcon = "/static/img/IconSprite.svg#exit"
export const backIcon = "/static/img/IconSprite.svg#back"
